"use strict";

var _slicedToArray = require("/home/node/workspace/viz-client/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var defaults = {
  tickLength: 5,
  color: 'black',
  padding: 10
};
/**
 *
 * @param param0
 * @returns
 */
var AtomSVGAxis = function AtomSVGAxis(_ref) {
  var ticks = _ref.ticks,
    scale = _ref.scale,
    orientation = _ref.orientation,
    _ref$tickLength = _ref.tickLength,
    tickLength = _ref$tickLength === void 0 ? defaults.tickLength : _ref$tickLength,
    offset = _ref.offset,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? defaults.color : _ref$color,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? defaults.padding : _ref$padding,
    format = _ref.format,
    _ref$domain = _ref.domain,
    domain = _ref$domain === void 0 ? false : _ref$domain,
    _ref$domainLength = _ref.domainLength,
    domainLength = _ref$domainLength === void 0 ? 0 : _ref$domainLength,
    _ref$domainMargin = _ref.domainMargin,
    domainMargin = _ref$domainMargin === void 0 ? 0 : _ref$domainMargin;
  var _offset = _slicedToArray(offset, 2),
    offsetX = _offset[0],
    offsetY = _offset[1];
  var positioning = {
    'left': {
      g: [function () {
        return offsetX;
      }, function (t) {
        return scale(t) + offsetY;
      }],
      x1: 0,
      y1: 0,
      x2: tickLength,
      y2: 0
    },
    'right': {
      g: [function () {
        return offsetX;
      }, function (t) {
        return scale(t) + offsetY;
      }],
      x1: -tickLength,
      y1: 0,
      x2: 0,
      y2: 0
    },
    'top': {
      g: [function (t) {
        return scale(t) + offsetX;
      }, function () {
        return offsetY;
      }],
      x1: 0,
      y1: -tickLength,
      x2: 0,
      y2: 0
    },
    'bottom': {
      g: [function (t) {
        return scale(t) + offsetX;
      }, function () {
        return offsetY;
      }],
      x1: 0,
      y1: 0,
      x2: 0,
      y2: tickLength
    }
  };
  var textAttrs = {
    'left': {
      anchor: 'end',
      baseline: 'middle',
      x: -padding,
      y: 0
    },
    'right': {
      anchor: 'start',
      baseline: 'middle',
      x: padding,
      y: 0
    },
    'top': {
      anchor: 'middle',
      baseline: 'auto',
      x: 0,
      y: -padding
    },
    'bottom': {
      anchor: 'middle',
      baseline: 'hanging',
      x: 0,
      y: padding
    }
  };
  var domainPosition = {
    'left': {
      x1: offsetX,
      x2: offsetX,
      y1: offsetY + domainMargin,
      y2: offsetY + domainMargin + domainLength
    },
    'right': {
      x1: offsetX,
      x2: offsetX,
      y1: offsetY + domainMargin,
      y2: offsetY + domainMargin + domainLength
    },
    'top': {
      x1: offsetX + domainMargin,
      x2: offsetX + domainMargin + domainLength,
      y1: offsetY,
      y2: offsetY
    },
    'bottom': {
      x1: offsetX + domainMargin,
      x2: offsetX + domainMargin + domainLength,
      y1: offsetY,
      y2: offsetY
    }
  };
  return react_1.default.createElement("g", null, domain && react_1.default.createElement("line", {
    className: 'domain',
    stroke: color,
    x1: domainPosition[orientation].x1,
    x2: domainPosition[orientation].x2,
    y1: domainPosition[orientation].y1,
    y2: domainPosition[orientation].y2
  }), ticks.map(function (tick) {
    var position = positioning[orientation];
    var _position$g = _slicedToArray(position['g'], 2),
      gx = _position$g[0],
      gy = _position$g[1];
    var textAttr = textAttrs[orientation];
    return react_1.default.createElement("g", {
      key: tick,
      className: 'tick',
      transform: "translate(".concat(gx(tick), ", ").concat(gy(tick), ")")
    }, react_1.default.createElement("line", {
      stroke: color,
      strokeOpacity: 0.5,
      x1: position['x1'],
      x2: position['x2'],
      y1: position['y1'],
      y2: position['y2']
    }), react_1.default.createElement("text", {
      fill: color,
      textAnchor: textAttr['anchor'],
      dominantBaseline: textAttr['baseline'],
      x: textAttr['x'],
      y: textAttr['y']
    }, format ? format(tick) : tick));
  }));
};
exports.default = AtomSVGAxis;